import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import intl from 'react-intl-universal';
import { getTimeByUtcOffset } from '@/utils/intl';
import { DATE_TIME_FORMAT } from '@/config';

import { parseFen2Currency } from '@/utils/number';

import { BILL_TYPE_MAP, BILL_STATE_MAP } from '../config';

import styles from './index.module.scss';

function PartSettleTable(props) {
  const { dataList } = props;

  const columns: ColumnsType<any> = [
    {
      title: intl.get('bill_refound_res_room_no'),
      dataIndex: 'roomNo',
      render: (v) => v || '-',
    },
    {
      title: intl.get('bill_entry_bill_type'),
      dataIndex: 'postType',
      render: (type) => (BILL_TYPE_MAP[type] ? BILL_TYPE_MAP[type] : '-'),
    },
    {
      title: intl.get('bill_refound_res_bill_subject'),
      dataIndex: 'subjectCodeName',
      render: (v) => v || '-',
    },
    {
      title: intl.get('bill_refound_res_detail'),
      width: 500,
      dataIndex: 'detail',
      render: (v) => v || '-',
    },
    {
      title: intl.get('bill_refound_res_pay'),
      dataIndex: 'amount',
      align: 'right',
      render: (val, record) => {
        // 付款和退款，退款为负
        if ([1, 4].includes(record.postType)) {
          return <span>{parseFen2Currency(record.postType === 4 ? -val : val)}</span>;
        }
        return '-';
      },
    },
    {
      title: intl.get('bill_config_consume'),
      dataIndex: 'amount',
      align: 'right',
      render: (val, record) => {
        // 消费、冲调、优惠，冲调和优惠为负
        if ([0, 2, 3].includes(record.postType)) {
          return <span>{parseFen2Currency([2, 3].includes(record.postType) ? -val : val)}</span>;
        }
        return '-';
      },
    },
    {
      title: intl.get('bill_invoice_modal_time'),
      dataIndex: 'createTime',
      render: (val) => getTimeByUtcOffset(val, DATE_TIME_FORMAT),
    },
    {
      title: intl.get('bill_operator'),
      dataIndex: 'createBy',
      render: (v) => v || '-',
    },
    {
      title: intl.get('bill_check_status'),
      dataIndex: 'status',
      render: (status) => (BILL_STATE_MAP[status] ? BILL_STATE_MAP[status] : '-'),
    },
    {
      title: intl.get('bill_remark'),
      dataIndex: 'remark',
      render: (val) => val || '-',
    },
  ];

  return (
    <Table
      className={styles['partSettle-table']}
      rowKey="no"
      rowClassName={(record) => {
        // 冲调、优惠、退款
        if ([2, 3, 4].includes(record.postType)) return 'red-table-cell';
        return '';
      }}
      dataSource={dataList}
      columns={columns}
      pagination={false}
    />
  );
}

export default PartSettleTable;
